import type { ComponentProps } from "react"

export default function CompassNeedle(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9239 7.48602L7.99993 0.348022L5.07593 7.48602L7.99993 15.848L10.9239 7.48602ZM6.31393 8.00002H9.68593L7.99993 12.819L6.31393 8.00002Z"
        fill={fill}
      />
    </svg>
  )
}
